import { InvestmentTransactionType } from "hooks/investments/GetInvestmentTransactionsHook";
import { InvestmentType } from "types/InvestmentTypes";
import { TYPE_LABELS, formatDate, FileCell, DotsMenu } from "./tableUtils";

interface CryptoTableProps {
  transactions: InvestmentTransactionType[];
  item: InvestmentType | null;
  isOwn?: boolean;
  onEditTx?: (tx: InvestmentTransactionType) => void;
}

const CryptoTable = ({
  transactions,
  item,
  isOwn = false,
  onEditTx,
}: CryptoTableProps) => (
  <table className="itm-table">
    <thead>
      <tr>
        <th>Transakcja</th>
        <th>Data</th>
        <th>Ilość sztuk</th>
        <th>Umowa</th>
        <th>Kurs</th>
        <th>Koszt nabycia</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {transactions.map((tx) => {
        const quantity = tx.quantity ?? null;
        const rate = tx.totalValue != null ? Number(tx.totalValue) : null;
        const cost = quantity != null && rate != null ? quantity * rate : null;
        const currencyCode = tx.currency?.currency ?? "";

        const fmtNum = (val: number) =>
          val.toLocaleString("pl-PL", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          });

        return (
          <tr key={tx.uuid}>
            <td>{TYPE_LABELS[tx.type] ?? tx.type}</td>
            <td>{formatDate(tx.completedAt ?? tx.createdAt)}</td>
            <td>
              {tx.type === "buy" ? "+" : "-"}
              {quantity != null ? fmtNum(quantity) : "—"}
            </td>
            <td>
              <FileCell tx={tx} />
            </td>
            <td>{rate != null ? fmtNum(rate) : "—"}</td>
            <td>
              {cost != null
                ? `${fmtNum(cost)}${currencyCode ? ` ${currencyCode}` : ""}`
                : "—"}
            </td>
            <td>
              <DotsMenu
                tx={tx}
                onEdit={
                  isOwn || tx.type === "sell" ? () => onEditTx?.(tx) : undefined
                }
              />
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
);

export default CryptoTable;
